import styled from 'styled-components';
import { TopMenuItem, breakpoints } from '~/src/components/Header/styled';
import { HeaderPhone } from '~/src/components/Header/styled';
import { COLORS, FONTS } from '@stelecom/ui-react/assets/js/constants';
import avatar from '~/static/images/header/avatart.svg';
import exit from '~/static/images/header/exit.svg';

export { TopMenuItem } from '~/src/components/Header/styled';

export const StyledTopMenuItem = styled(TopMenuItem)`
  margin-right: 100px;
`;
const cityColor = '#656565';
const colorsConstants = {
  darkGrey: '#505050',
};
export const RightMenu = styled.div`
  margin-left: auto;
  position: relative;
  ${FONTS.XXS};
  flex-wrap: nowrap;

  @media (max-width: ${breakpoints.sDesktop}) {
    margin-left: 36px;
    justify-content: center;
  }
  @media (max-width: ${breakpoints.tablet}) {
    width: 100%;
    display: flex;
    margin-left: auto;
    justify-content: space-between;
  }
  @media (max-width: 400px) {
    flex-direction: column;
  }
`;

export const CitySelect = styled(TopMenuItem)`
  color: ${cityColor};
  cursor: pointer;
  margin-right: 16px;
  ${FONTS.Medium};

  @media (max-width: ${breakpoints.sDesktop}) {
    display: none;
  }
`;

export const HeaderPhoneRight = styled(HeaderPhone)`
  color: ${colorsConstants.darkGrey};

  &:last-child {
    margin-right: 40px;
    padding-left: 0;
  }
`;

export const ImgWrapper = styled.div`
  margin-right: 4px;
`;

export const ExitElement = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  height: 19px;
  width: 19px;
  z-index: 2;
  @media(max-width: 453px){
    top:0;
  }
  @media(max-width: 389px){
    height: 15px;
    width: 15px;
    top:4px;
  }
  
`;
export const Name = styled.span<{ content: string }>`
  align-self: center;
  ${FONTS.Medium};
  color: ${COLORS.black};
  padding-right: 60px;
  padding-left: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  &:before {
    position: absolute;
    right: 20px;
    top: 18px;
    content: "";
    align-self: center;
    background: url(${exit}) no-repeat center;
    background-size: contain;
    height: 19px;
    width: 19px;
    z-index: 1;  
  }
  &:after {
    position: absolute;
    left: -10px;
    top: 19px;
    content: "";
    align-self: center;
    background-image: url(${avatar});
    background-size: contain;
    color: ${COLORS.white};
    font-size: 11px;
    line-height: 15px;
    height: 19px;
    width: 18px;
    text-align: center;
    z-index: 1;
  }

  @media (max-width: ${breakpoints.sDesktop}) {
    &:after {
      //display: none;
    }
    &:before {
      // display: none;
    }
  }

  @media (max-width: ${breakpoints.sMobile}) {
     padding-left: 30px;
  }

  @media (max-width: 400px) {
    &:before {
      top: -2px;
    }

    &:after {
      top: 0;
      left: -5px;
    }
  }
`;

export const HideOnMobile = styled.div`
  @media (max-width: ${breakpoints.mobile}) {
    display: none;
  }
`;

export const Login = styled.div`
  color: ${COLORS.black};
  position: relative;

  &:hover {
    color: ${COLORS.brightBlue};
  }

  &:after {
    position: absolute;
    top: 1px;
    left: -20px;
    content: "";
    width: 18px;
    height: 18px;
    background: url("${require('~/static/images/menu/auth-new.svg')}") no-repeat;
  }
  &:before {
    position: absolute;
    right: -41px;
    top: 0;
    content: "";
    align-self: center;
    background-image: url(${exit});
    height: 19px;
    width: 19px;
    z-index: 1;
  }
`;
export const PhoneWrapper = styled.div`
  @media (max-width: ${breakpoints.tablet}) {
    margin-left: 16px;
  }
`;
